import {
	FontIconName,
	Icon,
	IconValue,
	isSvgIcon,
	SvgIconValue
} from "../../Icon/Icon";
import { ReactElement, useMemo } from "react";

export type ActionBarButtonIconProps = {
	icon?: FontIconName | SvgIconValue;
};

export const ActionBarButtonIcon = (props: ActionBarButtonIconProps): ReactElement | null => {
	const { icon } = props;

	const iconProps: IconValue | null = useMemo(
		() => {
			if (!icon) {
				return null;
			}

			if (isSvgIcon(icon)) {
				return icon;
			}

			return {
				kind: "font",
				name: icon,
				color: "primary"
			};
		},
		[icon]
	);

	if (!iconProps) {
		return null;
	}

	return <Icon value={iconProps} />;
};

ActionBarButtonIcon.displayName = "ActionBarButtonIcon";
